import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_USER_PROJECT_BRAND_VOICE } from './schema';

const MUTATION = gql`
  mutation UpdateUserProjectBrandVoice(
    $projectId: ID!
    $brandVoiceId: ID!
    $generationTool: GenerationToolEnum!
    $key: BrandVoiceKeyEnum
    $updateAll: Boolean
  ) {
    updateUserProjectBrandVoice(
      projectId: $projectId
      brandVoiceId: $brandVoiceId
      generationTool: $generationTool
      key: $key
      updateAll: $updateAll
    ) {
      ...UserProjectBrandVoice
    }
  }
  ${FRAGMENT_USER_PROJECT_BRAND_VOICE}
`;

export const updateUserProjectBrandVoice = async (variables) => {
  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables,
    })
    .then(({ data }) => getSingleProp(data));
};
